import { format } from 'date-fns';

export const Roles = {
  admin: "admin",
  employee: "employee",
  hr: "hr",
  bde: "bde",
  bde_manager: "bde-manager",
  tl: "tl"
};

export const monthNames = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'
];
export const weekNames = [
  'Monday', 'TuesDay', 'WednesDay', 'ThursDay', 'Friday'
];
export const formatDateToISODateString = (date: Date): string => {
  const adjustedDate = new Date(
    date.getTime() - date.getTimezoneOffset() * 60000
  );
  const isoString = adjustedDate.toISOString();
  const dateString = isoString.split("T")[0];
  return dateString;
};

export const style: { [key: string]: string } = {
  finished: "bg-green-200 text-green-800 font-semibold px-2 py-1 rounded",
  query: "bg-red-200 text-red-400 font-semibold px-2 py-1 rounded",
  "in progress":
    "bg-yellow-200 text-yellow-800 font-semibold px-2 py-1 rounded",
  todo: "bg-blue-200 text-blue-800 font-semibold px-2 py-1 rounded",
  backLog: "bg-red-500 text-white font-semibold px-2 py-1 rounded",
  active: "bg-green-200 text-green-800 font-semibold px-2 py-1 rounded",
  inactive: "bg-red-200 text-red-800 font-semibold px-2 py-1 rounded",
};

export const styles: any = {
  Active: "bg-green-300 rounded",
  InActive: "bg-red-400 rounded",
  pending: "bg-yellow-200 rounded text-yellow-800 font-semibold px-2 py-1",
  reject: "bg-red-200 rounded text-red-800 font-semibold px-2 py-1",
  approve: "bg-green-200 rounded text-green-800 font-semibold px-2 py-1",
};

export const leadStyes: any = {
  New: "bg-blue-100 text-blue-800 rounded font-semibold px-2 py-1 ",
  "Send For Review":
    "bg-purple-100 text-purple-800 rounded font-semibold px-2 py-1 ",
  Approved: "bg-green-100 text-green-800 rounded font-semibold px-2 py-1 ",
  Rejected: "bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  Skip:"bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  Contacted: "bg-indigo-100 text-indigo-800 rounded font-semibold px-2 py-1 ",
  "Follow-Up": "bg-yellow-100 text-yellow-800 rounded font-semibold px-2 py-1 ",
  Converted: "bg-emerald-100 text-emerald-800 rounded font-semibold px-2 py-1 ",
  Lost: "bg-red-200 text-red-800 rounded font-semibold px-2 py-1 ",
  Duplicate: "bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  "Not Interested":
    "bg-gray-300 text-gray-800 rounded font-semibold px-2 py-1 ",
  "On Hold": "bg-orange-100 text-orange-800 rounded font-semibold px-2 py-1 ",
  Reminder: "bg-cyan-100 text-cyan-800 rounded font-semibold px-2 py-1 ",
  "Practical Needed":"bg-orange-100 text-orange-800 rounded font-semibold px-2 py-1",
  "Call NA":"bg-gray-300 text-gray-800 rounded font-semibold px-2 py-1 ",
  "TL Action":"bg-purple-400 text-black rounded font-semibold px-2 py-1 ",
  "HR Action":"bg-blue-100 text-blue-800 rounded font-semibold px-2 py-1 ",
  "HR Rejection":"bg-green-400 text-black rounded font-semibold px-2 py-1 ",
  "High Salary":"bg-purple-100 text-purple-800 rounded font-semibold px-2 py-1 ",
  "Schedule Rejection":"bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  Hold: "bg-gray-300 text-gray-800 rounded font-semibold px-2 py-1 ",
  Query: "bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  Scheduled: "bg-green-100 text-green-800 rounded font-semibold px-2 py-1 ",
  Schedule: "bg-green-100 text-green-800 rounded font-semibold px-2 py-1 ",
  Rejection: "bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
  "Email Issue": "bg-red-100 text-red-800 rounded font-semibold px-2 py-1 ",
};

export const stylePriority: any = {
  low: "bg-green-200 rounded",
  high: "bg-red-200 rounded",
  urgent: "bg-orange-200 rounded",
};

export type ViewType = "view" | "edit";

export const updateComponent = (
  type: ViewType,
  setView?: (value: any | null) => void,
  setEdit?: (value: string | null) => void
) => {
  switch (type) {
    case "view":
      setView?.(null);
      break;
    case "edit":
      setEdit?.(null);
      break;
  }
};

export const limit = 10;

export const handleLogout = () => {
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.clear();
  window.location.href = "/";
};

export function formatDate(value: string | Date): string {
  try {
    const date = new Date(value);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const isToday = date.getTime() === today.getTime();
    const isYesterday =
      date.getTime() === new Date(today.setDate(today.getDate() - 1)).getTime();
    const isTomorrow =
      date.getTime() === new Date(today.setDate(today.getDate() + 2)).getTime();

    if (isToday) return "Today";
    if (isYesterday) return "Yesterday";
    if (isTomorrow) return "Tomorrow";

    return format(date, "dd MMM yyyy");
  } catch (error) {
    return "Invalid Date";
  }
}

export function formatDateCSV(value: string | Date): string {
  try {
    const date = new Date(value);

    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return format(date, "dd MMM yyyy");
  } catch (error) {
    return "Invalid Date";
  }
}

export function formatTime(value: string | Date): string {
  try {
    const date = new Date(value);
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return "Invalid Time";
    }

    const ISTOffset = 330; // IST is UTC+5:30
    const ISTTime = new Date(date.getTime() + ISTOffset);

    const hours = ISTTime.getHours();
    const minutes = ISTTime.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format

    return `${formattedHours}:${minutes} ${ampm}`;
  } catch (error) {
    return "Invalid Time";
  }
}

export const DOC_BASE_URL = "https://documents.blisslers.com/emsdevdoc/";

export const months = [
  { value: "11", label: "November" },
  { value: "12", label: "December" },
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
];

export function formatDateToYYYYMMDD(dateString: string): string {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  } catch (error) {
    return "Invalid Date";
  }
}
